import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'

import Page from '../../components/layout/Page'
import Container from '../../components/layout/Container'
import FullSizeSection from '../../components/layout/FullSizeSection'
import FullSizePage from '../../components/layout/FullSizePage'
import FullSizeGallery from '../../components/layout/FullSizeGallery'
import { ApplicationState, ConnectedReduxProps } from '../../store'
import { Author } from '../../store/authors/types'
import { fetchRequest, fetchByName } from '../../store/authors/actions'
import { bulkUpdate } from '../../store/authors/actions'
import styled, { Theme } from '../../utils/styled'
import StringHelper from '../../utils/StringHelper'
import Loadingbar from '../../components/layout/Loaderbar'
import { darken } from 'polished'
import { Themed } from 'react-emotion'
import { Dispatch } from 'redux'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faArrowLeft, faArrowUp } from '@fortawesome/free-solid-svg-icons'

library.add(faArrowRight, faArrowLeft, faArrowUp)
// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
  loading: boolean
  data: Author[]
  selected: Author[]
  errors?: string
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest
  fetchByName:  typeof fetchByName
  bulkUpdate: typeof bulkUpdate
}

interface RouteParams {
  name: string
}

interface State {
  selected?: Author
}
// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState &
  PropsFromDispatch &
  RouteComponentProps<RouteParams> &
  ConnectedReduxProps

class ShowAuthorsPage extends React.Component<AllProps, State> {
  constructor(props: AllProps) {
    super(props)
    this.state = {
      selected: undefined
    }
  }
  private goto(event:any) {
    const  route = $(event.currentTarget).attr("to")
    this.props.history.push(route);


  }
  public componentDidMount() {
    const { selected, match } = this.props

      if (match.params.name!=null) {
      this.props.fetchByName(match.params.name)
    }
  }

  public createMarkup(str: string) {
    return {
      __html: str
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // console.log('author getDerivedStateFromProps', nextProps, prevState, prevState.data)
    let hasData = false;
    if (prevState.selected!=undefined){
      if (prevState.selected.length>0) {
        hasData = true;
      }
    }
    if (prevState.location!=nextProps.location) {
      const { selected, match } = nextProps
      // console.log("getDerivedStateFromProps match", match.params.name, nextProps);
      nextProps.fetchByName(match.params.name)
    }
    // console.log("do update",!hasData, nextProps.data.length>0);
    if (!hasData && nextProps.data.length>0) {
      const { selected, loading, match } = nextProps;
      // console.log("nextProps", nextProps.data);
      // nextProps.selected = selected;
      if (nextProps.selected!=null) {
        const selected = nextProps.selected;//.find(item => StringHelper(item.url_name) === match.params.name)
      // console.log('getDerivedStateFromProps select', selected)
      if selected.hasOwnProperty('id') {
      //  nextProps.update(selected.id);
      }
    }
    //   // return { someState: nextProps.someValue};
  }
    return nextProps
  }


  public render() {

    const { selected, loading, match } = this.props
    return (
      <Page>
        <Container>
          <Wrapper>
            {loading && <Loadingbar />}

            {selected!=undefined && (
              <div>
                <Buttons>
                {selected.hasOwnProperty('previous') && (<PreviousButton role="button" onClick={this.goto.bind(this)} to={`/about/${(selected.previous.url_name)}`}><FontAwesomeIcon icon={faArrowLeft} /> {selected.previous.name}</PreviousButton>)}
                {selected.hasOwnProperty('next') && (<NextButton role="button" onClick={this.goto.bind(this)} to={`/about/${(selected.next.url_name)}`}>{selected.next.name} <FontAwesomeIcon icon={faArrowRight} /></NextButton)}
                <BackButton role="button" onClick={this.goto.bind(this)} to={`/about`}><FontAwesomeIcon icon={faArrowUp} /></BackButton>
                </Buttons>
                <FullSizeSection
                  title={selected.name}
                  // subtitle={selected.hasOwnProperty('category') ? selected.category.name : ""}
                  backgroundImage={
                    selected.hasOwnProperty('cover') ? selected.cover.url : undefined
                  }
                  className="author"
                >
                  <div dangerouslySetInnerHTML={this.createMarkup(selected.description)} />
                </FullSizeSection>
  {selected.pages!=null && selected.pages.length>1 && (selected.pages.map((page, index) => (
    <FullSizePage
      key={index}
      title={page.title}
      subtitle={page.subtitle}
      media={page.hasOwnProperty('media') ? page.media : undefined}
      theme={page.theme}
      className={page.hasOwnProperty('media') ? "author-image" : "author"}
    >

      <div dangerouslySetInnerHTML={this.createMarkup(page.body)} />
    </FullSizePage>
  ))}
                {selected.hasOwnProperty('galleryid') && selected.galleryid>0 && (
                  <FullSizeGallery galleryid={selected.galleryid} />
                )}
              </div>
            )}

          </Wrapper>
        </Container>
      </Page>
    )
  }
}
const html = function(body: string) {
  let regex = /userdata/gi
  body = body.replace(regex, 'http://localhost/userdata')
  console.log(body)
  let result = [body]
  return result
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = ({ authors }: ApplicationState) => ({
  loading: authors.loading,
  errors: authors.errors,
  data: authors.data,
  selected: authors.selected
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchRequest: () => dispatch(fetchRequest()),
  fetchByName: (name:string) => dispatch(fetchByName(name)),
  fetchImage: (id: number) => dispatch(fetchImage(id)),
  bulkUpdate: () => dispatch(bulkUpdate())
})

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShowAuthorsPage)

const Wrapper = styled('div')`
  position: relative;
`
const Buttons = styled('div')`
  position:fixed;
  top:0px;
  z-index: 10;
  height: 45px;
  /* background-color: rgba(0,0,0,.4); */
  width: 100%;
  a {
    position:fixed;
    top:10px;
    z-index: 10;
    color: #fff!important;
    text-shadow: 1px 0px rgba(0,0,0,.5);
    background-color: rgba(0,0,0,.4);
    padding: 0px .5em;
    cursor: pointer;
  }
`
const NextButton = styled('a')`
  right: 100px;
`
const PreviousButton = styled('a')`
  left: 20px;
`

const BackButton = styled('a')`
  left: 50%;
  transform: translate(-50, 0%);
`
